/**
 * La domanda «vuoi ricevere le offerte via email?», lato app (02/11/2026).
 *
 * Chi si iscrive dal sito risponde con la casella del modulo; chi era gia'
 * iscritto ha il si' di partenza (scelta di Davide: continua finche' non dice
 * no). Restano senza risposta gli account creati da Datacom dal pannello (la
 * campagna telefonica) e quelli entrati con Google o Apple: a loro l'app lo
 * chiede UNA volta, sotto la testata della chat, finche' non rispondono.
 * La regola del server (chi riceve cosa) sta in
 * supabase/functions/_shared/consenso_marketing.ts.
 */
import type { Profile } from "@/hooks/useAuth";

const DOMINI_INTERNI = ["@datacomtecnologie.it", "@b2brand.it"];

export const DOMANDA_CONSENSO =
  "Vuoi ricevere via email le offerte, le novità, i corsi e i listini di Datacom?";

/**
 * Si chiede solo a chi non ha mai risposto (null). undefined vuol dire che la
 * colonna non c'e' ancora (migrazione non applicata): non si chiede niente.
 * Mai agli account dei costruttori, agli admin e al team interno (compreso
 * l'account dei revisori degli store, che e' @b2brand.it).
 */
export function chiedereConsenso(profilo: Profile | null, email: string | null | undefined): boolean {
  if (!profilo || profilo.consenso_marketing !== null) return false;
  if (profilo.account_prova === true || profilo.is_admin === true) return false;
  const e = (email ?? "").trim().toLowerCase();
  if (!e || DOMINI_INTERNI.some((d) => e.endsWith(d))) return false;
  return true;
}
